import initializeComponent from 'Shared/react-initialize';
import { BreadCrumbs } from '@ifixit/breadcrumbs';
import { type BreadcrumbData, toCrumbs } from './navBreadcrumbs';

const NavBreadcrumbs = ({ breadcrumbs }: { breadcrumbs: BreadcrumbData[] }) => {
   if (!breadcrumbs) {
      return null;
   }

   return (
      <div className="flex h-full w-full pl-4">
         <BreadCrumbs breadCrumbs={toCrumbs(breadcrumbs)} includeSchema />
      </div>
   );
};

initializeComponent('NavBreadcrumbs', NavBreadcrumbs);
